export default __webpack_public_path__ + "static/cafe_36058-daf3991d0ff629d7e430713610c85a11.png";